import { toast } from "react-toastify";
import { BasicPage } from "../../../theme/Component/BasicPage"
import { ListMenu } from "../../../theme/Component/ListMenu";
import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import useModal, { MODAL_LG, MODAL_SM } from "../../../theme/Component/hooks/useModal";
import { _QualityMeasurementInspections, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { QualityMeasurementInspectionsItems } from "./QualityMeasurementInspectionsItems/QualityMeasurementInspectionsItems";
import { SelectQualityGarment } from "../QualityGarment/SelectQualityGarment";
import usePaginator from "../../../theme/Component/usePaginator";
import { BasicButton } from "../../../theme/Component/BasicButton";

interface DataForm {
    IDGarment: number;
}

export const QualityMeasurementInspections = () => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_QualityMeasurementInspections);
    const paginador = usePaginator();

    const [form, setForm] = useState<Partial<DataForm>>({});

    const modal = useModal("", MODAL_LG)
    const modalC = useModal("Eliminar", MODAL_SM)
    const modalTolerance = useModal(`Tolerancias de ${bean.Name}`, MODAL_LG)

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {
        const props: any = {
            State: 1
        }

        if (form.IDGarment) props.IDQualityGarment = form.IDGarment;

        instance.getQualityMeasurementInspectionsRender(paginador.page, 15, props).then((resp: any) => {

            resp.List.forEach(element => {
                const data = element.DataBeanProperties;

                data.EntityGarment = data.IDQualityGarment ? `${data.GarmentCode} - ${data.GarmentName}` : "N/A"
            });

            setLista(resp.List);
            paginador.setPages(resp.NumberOfPages);
            paginador.setRecords(resp.NumberOfPages * (15));
        }).catch(err => {
            toast.error("Error al cargar la lista de cotas");
        });
    };

    const create = () => {
        setBean({
            State: 1,
            IDEmployee: _single.getAccountID(),
        });
        modal.open("Agregar Cota");
    }

    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        editaItem(x);
    };

    const editaItem = (obj: any) => {
        instance.updateQualityMeasurementInspections(obj).then(
            (resp: any) => {
                getLista();
                modalC.close();
                modal.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDQualityMeasurementInspections', visible: true },
        { title: 'Código', property: 'CodeMeasurement', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Prenda', property: 'EntityGarment', visible: true },
    ];


    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open(`Editar cota ${bean.Name}`) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalC.open() } },
            { titulo: 'Tolerancia de las cotas', icono: 'ri-list-check', visible: true, evento: () => { modalTolerance.open(); } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem(bean);
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "Name"
        ];
        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    return (
        <BasicPage titulo="Cotas">
            <div className="row">
                <div className="col-md-4">
                    <SelectQualityGarment idSelector={form.IDGarment} onChange={(e) => { setForm({ ...form, IDGarment: e }) }} label="Prenda" />
                </div>
                <div className="col-md-3">
                    <BasicButton eventClick={() => { getLista() }} icon="ri-search-line" children={`Buscar`} useMargin />
                </div>
                <div className="col-md-12">
                    <BasicTable
                        body={lista}
                        head={head}
                        rowSet={setBean}
                        listButtons={listaBotones()}
                        iconButtons={iconButtonsItem}
                        next={paginador.next}
                        pageTop={paginador.page}
                        back={paginador.back}
                        records={paginador}
                    />

                    <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { validateData() }}>
                        <div className="row">
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('Name') ? 'has-error' : ''}`} >Nombre</label>
                                <input type="text" className="form-control" value={bean.Name} onChange={(e) => { setBean({ ...bean, Name: e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('CodeMeasurement') ? 'has-error' : ''}`} >Código</label>
                                <input type="text" className="form-control" value={bean.CodeMeasurement} onChange={(e) => { setBean({ ...bean, CodeMeasurement: e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectQualityGarment idSelector={bean.IDQualityGarment} onChange={(e) => { setBean({ ...bean, IDQualityGarment: e }) }} label="Prenda" />
                            </div>
                            <div className="col-md-12">
                                <label className={`${missingFields.includes('Description') ? 'has-error' : ''}`} >Descripción</label>
                                <textarea value={bean.Description} className="form-control" onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} />
                            </div>
                        </div>
                    </Modal>

                    <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={deleteItem}>
                        <strong>Eliminar item {bean.Name}</strong>
                    </ModalConfirm>

                    <Modal modal={modalTolerance.modal} updateModal={modalTolerance.setModal} >
                        <QualityMeasurementInspectionsItems idQualityMeasurementInspection={bean.IDQualityMeasurementInspections} />
                    </Modal>
                </div>
            </div>
        </BasicPage>
    )
}